export const PERMISSIONS = {
  'Change Password': 'change password',
  Profile: 'profile',
  'Employee type': 'employee type',
  'Employee management': 'employee management',
  Admin: 'admin',
  Services: 'services',
  Report: 'report',
  Reports: {
    'Invoice to Company': 'report - invoice to company',
    'Actual vs Budget': 'report - actual vs budget',
  },
  'Device type': 'device type',
  'Vendor management': 'vendor management',
  'Estimated rates': 'estimated rates',
  Invoice: 'invoice',
  'Company management': 'company management',
  'SMTP Setup': 'smtp setup',
  'Fixed charges': 'fixed charges',
  'Service Category': 'service category',
  Employee: 'employee',
  Licences: 'licences',
  Manager: 'manager',
  'Estimated Rates': 'estimated rates',
  'Device Type': 'device type',
  'Company Management': 'company management',
  'Employee Management': 'employee management',
  'Employee Type': 'employee type',
  'Fixed Charges': 'fixed charges',
  'Vendor Management': 'vendor management',
  'User Management': 'user management',
};
